import { useCallback } from "react";
import { useAppSelector } from "../store/hook";
import { formatMoney, formatNumber } from "../utils/money";

// The logged-in admin's LoB currency. `symbol`/`code`/`locale` replace every
// hardcoded "₹" / "INR" / "en-IN"; `format` and `number` do the grouping.
export const useMoney = () => {
  const currency = useAppSelector((state) => state.lobConfig.currency);

  const format = useCallback(
    (amount: number | string | null | undefined, options?: Intl.NumberFormatOptions) =>
      formatMoney(amount, currency, options),
    [currency],
  );
  const number = useCallback(
    (amount: number | string | null | undefined, options?: Intl.NumberFormatOptions) =>
      formatNumber(amount, currency, options),
    [currency],
  );

  return { currency, symbol: currency.symbol, code: currency.code, locale: currency.locale, format, number };
};
